import { forEach, map, includes } from 'lodash';
import turf from '@turf/turf';

import * as annotationOps from '../../api/Annotations/annotation-operations';
import * as templateOps from '../../api/AnnotationTemplates/annotation-template-operations';
import { ELEMENT_TYPES, LABEL_TYPES } from '../../api/AnnotationTemplates/AnnotationTemplates';

import { usToDDHHMMSS } from '../dates';

/**
 * Generates an array of strings from the video annotations to export in pdf.
 *
 * @param {object[]} annotations - The video annotations.
 * @returns {string[]} An array of strings with each annotation information to export in pdf format.
 */
const generateAnnotationsPDF = annotations => {
  const pdfLines = map(annotations, (annotation, index) => {
    let pdf = `Annotation ${index + 1}\n\n`;
    pdf += `Coordinates: ${turf.getCoord(annotationOps.getGeoJSON(annotation))}\n`;
    pdf += `Video Time: ${usToDDHHMMSS(annotationOps.getVideoTime(annotation))}\n`;
    pdf += `Data:\n`;

    forEach(templateOps.getElements(annotationOps.getTemplate(annotation)), element => {
      switch (true) {
        case includes(LABEL_TYPES, templateOps.getElementType(element)):
          pdf += `\tText (${templateOps.getElementLabelName(
            element
          )}): ${templateOps.getElementValue(element)}\n`;
          break;

        case ELEMENT_TYPES.IMAGE === templateOps.getElementType(element):
          pdf += `\tImage: ${templateOps.getElementValue(element)}\n`;
          break;

        case ELEMENT_TYPES.VIDEO === templateOps.getElementType(element):
          pdf += `\tVideo: ${templateOps.getElementValue(element)}\n`;
          break;

        case ELEMENT_TYPES.IFRAME === templateOps.getElementType(element):
          pdf += `\tIframe: ${templateOps.getElementValue(element)}\n`;
          break;

        case includes(
          [ELEMENT_TYPES.LINK, ELEMENT_TYPES.ICON],
          templateOps.getElementType(element)
        ):
          pdf += `\tLink: ${templateOps.getElementValue(element)}\n`;
          break;

        default:
          break;
      }
    });

    pdf += '\n';

    return pdf;
  });

  return pdfLines;
};

export default generateAnnotationsPDF;
